// The binder keeps its selection in the URL so it survives a round trip through another
// page and lands back on the same folder.
export interface ColumnsSearch {
    /** Top-level folder code, e.g. `B` or `X`. */
    folder?: string;
    /** Leaf code within `folder`, e.g. `B004`. */
    sub?: string;
    /** A custom folder's id. Its own key rather than reusing `sub`, since `leafRowsFor`
     * assumes a four-character code and does `code.startsWith(upper)`. */
    custom?: string;
    /** Selected document id. */
    doc?: number;
}

function optionalString(value: unknown): string | undefined {
    return typeof value === 'string' && value !== '' ? value : undefined;
}

/**
 * Coerces `doc` because a route with no `validateSearch` hands the raw string through
 * while a route with one can already have parsed it to a number.
 */
export function parseColumnsSearch(search: Record<string, unknown>): ColumnsSearch {
    const doc = Number(search.doc);
    return {
        folder: optionalString(search.folder),
        sub: optionalString(search.sub),
        custom: optionalString(search.custom),
        doc: Number.isInteger(doc) && doc > 0 ? doc : undefined,
    };
}
